<div class="group relative w-full overflow-hidden rounded-lg" [class.video-landscape]="isHorizontal()"
    [class.video-portrait]="!isHorizontal() && !profileFrame()"
    [class.video-profile]="!isHorizontal() && profileFrame()">
    @if (!playbackActive()) {
    <div class="relative">
        <atom-video-thumbnail [videoUrl]="video().fullUrl" [videoFormat]="videoFormatForAtom()"
            [thumbnailURL]="thumbnailUrl()" [cdnKey]="thumbnailCdnKey()"></atom-video-thumbnail>
        <div
            class="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/0 transition-opacity duration-200 group-hover:bg-black/25 play-overlay-transition group-focus-within:bg-black/25">
            <button type="button"
                class="pointer-events-auto flex size-16 items-center justify-center rounded-full bg-white/90 text-accent shadow-md opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-focus-within:opacity-100 focus-visible:opacity-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary play-overlay-transition"
                (click)="onPlayClick()" aria-label="Play video">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
                    <path fill-rule="evenodd"
                        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                        clip-rule="evenodd" />
                </svg>
            </button>
        </div>
    </div>
    } @else {
    <div class="relative video-inner h-full min-h-0 w-full">
        <video #videoPlayer playsinline class="absolute inset-0 z-0 h-full w-full object-cover rounded-lg bg-black"
            (play)="onVideoPlay()" (pause)="onVideoPause()" (timeupdate)="onTimeUpdate()"
            (loadedmetadata)="onLoadedMetadata()" (volumechange)="onVolumeChange()">
        </video>
        <div
            class="w-full inline-video-controls absolute inset-x-0 bottom-0 z-20 flex flex-row items-center gap-2 bg-linear-to-t from-black/80 to-transparent px-2 pb-2 pt-6 text-white">
            <button type="button"
                class="flex size-12 shrink-0 items-center justify-center rounded-md hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                (click)="onControlBarPlayPause($event)" [attr.aria-label]="isPlaying() ? 'Pause' : 'Play'">
                @if (isPlaying()) {
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                    <path fill-rule="evenodd"
                        d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                        clip-rule="evenodd" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-6">
                    <path fill-rule="evenodd"
                        d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z"
                        clip-rule="evenodd" />
                </svg>
                }
            </button>
            <div class="flex-1 flex flex-col gap-y-0.5 items-start justify-center">
                <span class="shrink-0 tabular-nums text-xs font-medium text-white/90" aria-live="polite">
                    {{ formatTime(currentTimeSec()) }}
                </span>
                <div class="min-w-0 flex-1 flex flex-col justify-center py-1 w-full" role="group" aria-label="Seek">
                    <div tabindex="0" role="slider" [attr.aria-valuenow]="ariaTimeNow()" [attr.aria-valuemin]="0"
                        [attr.aria-valuemax]="ariaDurationMax()" aria-label="Video progress"
                        class="progress-hit cursor-pointer rounded-md px-0 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                        (mousedown)="onProgressPointerDown($event)" (touchstart)="onProgressPointerDown($event)"
                        (keydown)="onProgressKeyDown($event)">
                        <div class="h-1.5 w-full rounded-full bg-white/30">
                            <div class="h-full rounded-full bg-primary/65" [style.width.%]="progressPercent()"></div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button"
                class="inline-flex size-11 shrink-0 items-center justify-center rounded-md hover:bg-white/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                (click)="onToggleMute($event)" [attr.aria-label]="isMuted() ? 'Unmute' : 'Mute'">
                @if (isMuted()) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path d="M11 5 6 9H2v6h4l5 4V5Z" />
                    <line x1="23" x2="17" y1="9" y2="15" />
                    <line x1="17" x2="23" y1="9" y2="15" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                    <path d="M11 5 6 9H2v6h4l5 4V5Z" />
                    <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
                    <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                </svg>
                }
            </button>

        </div>
    </div>
    }
</div>